var EVIDON_CONST = {
  COUNTRY_LANGUAGE_OBJECT: {
    gb: {
      id: 6,
      code: 'gb',
      defaultLangauge: 'en-gb'
    },
    de: {
      id: 3,
      code: 'de',
      defaultLangauge: 'de'
    },
    fr: {
      id: 5,
      code: 'fr',
      defaultLangauge: 'fr'
    },
    be: {
      id: 20,
      code: 'be',
      defaultLangauge: 'nl'
    },
    nl: {
      id: 8,
      code: 'nl',
      defaultLangauge: 'nl'
    },
    lu: {
      id: 28,
      code: 'lu'
    },
    at: {
      id: 19,
      code: 'at'
    },
    it: {
      id: 7,
      code: 'it',
      defaultLangauge: 'it-it'
    },
    pt: {
      id: 26,
      code: 'pt',
      defaultLangauge: 'pt-pt'
    },
    es: {
      id: 4,
      code: 'es',
      defaultLangauge: 'es-es'
    }
  }
};
export default EVIDON_CONST;